import { v7 as uuidv7, validate, version } from 'uuid'

/**
 * Every id the phone makes (commands, sessions, lots, measurements, photos) is a UUIDv7: time
 * ordered, so server indexes stay append-friendly and ids sort in creation order.
 */
export function newId(): string {
  return uuidv7()
}

export function isUuidV7(value: string): boolean {
  return validate(value) && version(value) === 7
}

const CROCKFORD = '0123456789ABCDEFGHJKMNPQRSTVWXYZ'

/**
 * A ULID (26 chars, Crockford base32) for a delivery (`delivery_ulid`, F4.3). Made from a fresh
 * UUIDv7: both are 128 bits starting with the 48-bit Unix-ms time, so it sorts by time too.
 */
export function newUlid(uuid: string = uuidv7()): string {
  let n = BigInt(`0x${uuid.replace(/-/g, '')}`)
  let out = ''
  for (let i = 0; i < 26; i++) {
    out = CROCKFORD[Number(n & 31n)]! + out
    n >>= 5n
  }
  return out
}

export const ULID_RE = /^[0-9A-HJKMNP-TV-Z]{26}$/
